import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const PdfTextBlock = ({ block, index, onUpdate }) => {
    const [segments, setSegments] = useState(block || []);
    const editableDivRef = useRef(null);
    const lastHtml = useRef('');

    useEffect(() => {
        if (JSON.stringify(block) !== JSON.stringify(segments)) {
            setSegments(block || []);
        }
    }, [block]);

    const blockKey = useMemo(() => block.map(b => b.id).join('-'), [block]);

    useEffect(() => {
        if (!editableDivRef.current) return;

        const newHtml = block.map(segment => {
            // Use &nbsp; for empty strings to maintain editable space
            const content = segment.text === "" ? "&nbsp;" : segment.text;
            return `<span 
                data-id="${segment.id}" 
                data-paraId="${segment.paraId}" 
                data-textId="${segment.textId}" 
                data-sentId="${segment.sentId}"
                style="margin: 0 2px; display: inline; white-space: pre-wrap; word-break: break-word;"
            >${content}</span>`;
        }).join('');

        if (newHtml !== lastHtml.current) {
            editableDivRef.current.innerHTML = newHtml;
            lastHtml.current = newHtml;
        }
    }, [block]);


    const handlePaste = (e) => {
        e.preventDefault();
        const text = (e.clipboardData || window.clipboardData).getData('text/plain');
        document.execCommand('insertText', false, text);
        setTimeout(handleBlur, 0);
    };

    const handleBlur = useCallback(() => {
        if (!editableDivRef.current) return;

        const spans = editableDivRef.current.querySelectorAll('span');
        const newSegments = Array.from(spans).map((span, i) => {
            // Convert &nbsp; back to empty string
            const text = span.textContent === "\u00A0" ? "" : span.textContent;
            return {
                id: span.dataset.id || block[i]?.id || `new-${index}-${i}`,
                paraId: parseInt(span.dataset.paraId) || block[i]?.paraId || 0,
                textId: parseInt(span.dataset.textId) || block[i]?.textId || i,
                sentId: parseInt(span.dataset.sentId) || block[i]?.sentId || 0,
                text: text
            };
        });

        // console.log("Sending update with empty strings:", newSegments);
        onUpdate(index, newSegments);
    }, [block, index, onUpdate]);

    function getRandomNumber() {
        return Math.floor(Math.random() * 10) + 90;
    }

    return (
        <div className='d-flex gap-2 align-items-start'>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip">
                            Machine Translation Quality Prediction: Score indicating translation quality. High quality: above 0.75
                        </Tooltip>
                    }
                >
                <span className="bg-primary text-small text-nowrap fs_12 px-2 py-1 text-white rounded">
                        {getRandomNumber()}
                    </span>
                </OverlayTrigger>
            <div
                key={blockKey}
                ref={editableDivRef}
                contentEditable
                suppressContentEditableWarning
                onBlur={handleBlur}
                onPaste={handlePaste}
                className="p-1"
                style={{
                    width: '100%',
                    minHeight: '20px',
                    overflow: 'hidden',
                    textAlign: 'start',
                    fontSize: '14px',
                    lineHeight: '1.5',
                    borderRadius: '5px',
                    backgroundColor: "#ffff",
                    outline: "none",
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    maxWidth: '100%'
                }}
            />
        </div>
    );
};

export default React.memo(PdfTextBlock);